import React from 'react';

import { Modal, Button, Counter } from '@hpstellar/core';
import { Cross, ArrowRight } from '@hpstellar/icons';

import './filter-modal.less';

export default function FilterModal({
    children,
    isOpen,
    onModalClose,
    filterCount,
    resultsCount,
    clearFilters,
    className,
}) {
    return (
        <Modal
            aria-describedby="modal_description"
            aria-labelledby="modal_title"
            modalClassName="modalFilterContainer"
            onModalClose={onModalClose}
            isOpen={isOpen}
            className={className}
        >
            <div className="filterHeader">
                <button type="button" className="close" onClick={onModalClose}>
                    <Cross size="xs" />
                </button>
                {['string', 'number'].includes(typeof filterCount) && (
                    <Counter className="counter" count={filterCount} size="large" subsetDelimiter="of">
                        {`Filter${filterCount === 1 ? '' : 's'} Applied`}
                    </Counter>
                )}
            </div>
            <div className="filterContent">{children}</div>
            <div className="filterFooter">
                {clearFilters && (
                    <span className="clear">
                        <Button className="button" variation="tertiary" color="primary" onClick={clearFilters}>
                            CLEAR ALL
                        </Button>
                    </span>
                )}
                <span className="show">
                    <Button className="button" endIcon={<ArrowRight size="s" />} onClick={onModalClose}>
                        {`SHOW ${resultsCount} RESULT${resultsCount > 1 ? 'S' : ''}`}
                    </Button>
                </span>
            </div>
        </Modal>
    );
}
